import { GET_EKYC_POST_CHARGE, GET_EKYC_POST_PAYMENT } from './../../global';
import { EkycWorkStatusEnum } from './../../Enum/CommonEnum';
import { CheckUtil } from './../../utils/ChecksUtil';

import * as global from '../../global';
import { Http, ResponseContentType, Headers } from '@angular/http';
import { Injectable } from '@angular/core';

@Injectable()
export class ExportExcelService {
    btnDisable: boolean = true;
    constructor(public http: Http) { }

    getExcelInventoryHistoryByCode(typecode: number, companyId: number, pageNum, isExcel: boolean) {
        var urlForExcel = global.GET_ALL_INVENTORY_QUERY.concat("inventoryTypeCode:")
            .concat(typecode.toString()).concat(",purposeCode!2")
            .concat(",companyId:").concat(companyId.toString()).concat('&excel=') + isExcel;
        return this.getExcel(urlForExcel);
    }

     filterEkycCustomersExcelByQuery(query: string,isExcel:boolean) {

        var urlForExcel = global.FILTER_EKYC_CUSTOMER.concat(query).concat('&excel=') +isExcel;
                return this.getExcel(urlForExcel);

      }

      filterGenricCrmByQuery(query:string,isExcel:boolean,isAllPermission:string){
          var urlForExcel = global.FILTER_GENERIC_CRM.concat(query).concat("&allPermission=").concat(isAllPermission).concat('&excel=')+ isExcel;
          return this.getExcel(urlForExcel);
      }

      exportDataByUrl(url:string){
          return this.getExcel(url);
      }

      inventoryCollInGenCrm(query:string,isExcel:boolean){
          var urlForExcel = global.FILTER_DIS_INV_GENERIC_CRM.concat(query).concat('&excel=')+isExcel;
          return this.getExcel(urlForExcel);
      }
      getAssignedEmpInventory(empId:number,isExcel:boolean){
          var urlForExcel = global.GET_INVENTORY_UNASSIGNED_ITEMS.concat("?salesmanId=")
          .concat(empId.toString())
          .concat("&isAssigned=0&excel=")+isExcel;
          return this.getExcel(urlForExcel);
      }
      filterPostChargesByQuery(query:string,isExcel:boolean){
        var urlForExcel = global.GET_FILTER_POST_CHARGE.concat(query).concat('&excel=')+ isExcel;
        return this.getExcel(urlForExcel);
      }
      filterPostEkycPaymentByQuery(query:string,isExcel:boolean){
        var urlForExcel = global.GET_FILTER_EKYC_POST_PAYMENT.concat(query).concat('&excel=')+ isExcel;
        return this.getExcel(urlForExcel);
      }

      postChargesByQuery(isExcel:boolean){
        var urlForExcel = global.GET_EKYC_POST_CHARGE.concat('?excel=')+ isExcel;
        return this.getExcel(urlForExcel);
      }
      postEkycPaymentByQuery(isExcel:boolean){
        var urlForExcel = global.GET_EKYC_POST_PAYMENT.concat('?excel=')+ isExcel;
        return this.getExcel(urlForExcel);
      }

      productSearchByQuery(query:string){
          var urlForExcel = global.GET_PRODUCT_SEARCH_DETAIL
          .concat(query).concat("&embed=history&excel=true");
          
          return this.getExcel(urlForExcel);
      }


      filterPartenerCrmByQuery(query:string,isExcel:boolean){
        var urlForExcel = global.FILTER_GENERIC_CRM.concat(query).concat('&excel=')+ isExcel;
        return this.getExcel(urlForExcel);
    }
      getEkycPaymentLaterExcel(isExcel:boolean) {
        var urlForExcel = global.GET_PAYMENT_LATER_CUSTOMER.concat('&excel=') +isExcel;
                return this.getExcel(urlForExcel);
      }



     getEkycCustomersExcelByPage( type:string, assignQuery:string , isExcel:boolean) {
        var url = "";
        var typeValue = "";
        switch (type) {
          case "all":
            url = global.GET_CUSTOMER_BY_PAGE;
            break;
          case "pendingPayments":
            typeValue = EkycWorkStatusEnum.PENDING_PAYMENT + "&";
            url = global.GET_CUSTOMER_BY_STATUS_PAGE + typeValue;
            break;
          case "pendingApprovals":
            typeValue = EkycWorkStatusEnum.PENDING_APPROVAL + "&";
            url = global.GET_CUSTOMER_BY_STATUS_PAGE + typeValue;
            break;
          case "pendingAccount":
            typeValue = EkycWorkStatusEnum.PENDING_ACCOUNT + "&";
            url = global.GET_CUSTOMER_BY_STATUS_PAGE + typeValue;
            break;

          case "Wiring":
            typeValue = EkycWorkStatusEnum.PENDING_WIRING + "&";
            url = global.GET_CUSTOMER_BY_STATUS_PAGE + typeValue;
            break;
          case "Fibre":
            typeValue = EkycWorkStatusEnum.PENDING_FIBRE + "&";
            url = global.GET_CUSTOMER_BY_STATUS_PAGE + typeValue;
              break;
          case "Installation":
            typeValue = EkycWorkStatusEnum.PENDING_INSTALLATION + "&";
            url = global.GET_CUSTOMER_BY_STATUS_PAGE + typeValue;
            break;
          case "pending_confirmation":
            typeValue = EkycWorkStatusEnum.PENDING_CONFIRMATION + "&";
            url = global.GET_CUSTOMER_BY_STATUS_PAGE + typeValue;
            break;
          case "Closed":
            typeValue = EkycWorkStatusEnum.CLOSED + "&";
            url = global.GET_CUSTOMER_BY_STATUS_PAGE + typeValue;
            break;
          case "rejected":
            typeValue = EkycWorkStatusEnum.REJECTED + "&";
            url = global.GET_CUSTOMER_BY_STATUS_PAGE + typeValue;
            break;

        }
        var urlForExcel = url
        .concat('excel=') + isExcel;
        return this.getExcel(urlForExcel);
      }



    getExcelAllEnquiries( isExcel: boolean, createdFrom: string) {
        let mobileQuery = "";
        if (!CheckUtil.isNullorUndefined(createdFrom)) {
          mobileQuery = "&createdFrom=" + createdFrom;
        }
        console.log(createdFrom);

        var urlForExcel = global.GET_ALL_FUNNEL_CUSTOMER
        .concat('?embed=enquiryHistory,followUpHistory').concat(mobileQuery).concat('&excel=') + isExcel;
        return this.getExcel(urlForExcel);
    }

    getExcelEnquiriesByStatus(isExcel:boolean, status: string, id: number,createdFrom: string){

    let isNew="";
    if(status != "NEW")
    {
      isNew = "&assignedToEmployeeId="+id;
    }
    let mobileQuery = "";
        if (!CheckUtil.isNullorUndefined(createdFrom)) {
          mobileQuery = "&createdFrom=" + createdFrom;
        }
        var urlForExcel = global.GET_FUNNEL_CUSTOMER_BY_STATUS.concat(status).concat(isNew).concat(mobileQuery)
        .concat('&excel=') + isExcel;
        return this.getExcel(urlForExcel);
    }

    getExcelAllSales(isExcel:boolean){
        var urlForExcel = global.GET_ALL_LEAD_URL
        .concat('?embed=enquiry,leadHistory').concat('&excel=') + isExcel;
        return this.getExcel(urlForExcel);
    }
   // getExcelfilterCrm

   getExcelfilterSales(isExcel: boolean, searchQuery: string){
    var urlForExcel = global.GET_ALL_LEAD_FILTER
        .concat("?")
        .concat(searchQuery)
        .concat('&embed=enquiry,leadHistory')
        .concat('&excel=') + isExcel;
        return this.getExcel(urlForExcel);
   }

   getExcelSalesByStatus(isExcel: boolean, leadStatus:string, userId:number ){

    var urlForExcel = global.GET_ALL_LEAD_BY_STATUS.concat(leadStatus)
        .concat(status).concat('&assignedToEmployeeId='+userId)
        .concat("&embed=enquiry,leadHistory,followUpHistory")
        .concat('&excel=') + isExcel;
        return this.getExcel(urlForExcel);
   }

    getExcelfilterCrm( isExcel: boolean, searchQuery: string, cretedFrom:string) {
        let createdFrom = "";
        if (!CheckUtil.isNullorUndefined(cretedFrom)) {
          createdFrom = "&createdFrom=" + cretedFrom;
        }
        var urlForExcel = global.GET_FILTER_FUNNEL_CUSTOMER
        // .concat("?isCompletedEnquiry:false,")
        .concat("?")
        .concat(searchQuery).concat(createdFrom)
        // .concat('&embed=enquiryHistory')
        .concat('&excel=') + isExcel;
        return this.getExcel(urlForExcel);
    }


    getExcelfilterComplaints(type:string,isExcel: boolean, searchQuery: string){
        var urlForExcel = global.GET_ALL_CONNECTION_ISSUE_URL
        .concat('?query=type:'+type+',')
        .concat(searchQuery)
        .concat('&embed=enquiry,leadHistory')
        .concat('&excel=') + isExcel;
        return this.getExcel(urlForExcel);

    }
            // static getConnectionIssueFilter(type:string, searchQuery: string, pageNo: number, size: number) {
            //     const httpreq = new HttpRequest(global.GET_ALL_CONNECTION_ISSUE_URL
            //     .concat('?query=type:'+type+',')
            //     .concat(searchQuery)
            //     .concat("&size=").concat(size.toString())
            //     .concat("&page=").concat(pageNo.toString()));
            //   httpreq.classTypeValue = DisconnectionReportResponse;
            //   httpreq.taskcode = TaskCode.GET_CONNECTION_ISSUE_FILTER;
            //   return httpreq;
            //   }

    getExcelAllComplaints(type:string, isExcel: boolean){
        var urlForExcel = global.GET_ALL_CONNECTION_ISSUE_URL
        .concat('?query=')
        .concat('type:'+type)
        .concat('&embed=statusHistory,followUpHistory').concat('&excel=') + isExcel;
        return this.getExcel(urlForExcel);
    }

    getExcelComplaintsByStatus(type:string, isExcel:boolean, status: string, id: number ){
        var urlForExcel = global.GET_CON_BY_STATUS
        .concat('?type='+type)
        .concat('&status='+status)
        .concat('&assignedToEmployeeId='+id)
        .concat('&embed=statusHistory,followUpHistory')
        .concat('&excel=') + isExcel;
        return this.getExcel(urlForExcel);
}

    getExcelDisconnectionInventory(type:string, isExcel:boolean, status:string){
        var urlForExcel =  global.DISCONNECTION_INVENTORY_URL
        .concat('type='+type)
        .concat('&status='+status)
        .concat('&embed=statusHistory,followUpHistory')
        .concat("&excel=")+ isExcel;
        
        return this.getExcel(urlForExcel);
    }



    getExcelfilterInventoryHistoryCheckInByQuery(typecode: number,query: string, companyId: number, pageNum: string, isExcel: boolean, ) {
        var urlForExcel = global.FILTER_INVENTORY_BY_QUERY.concat(query)
            // .concat(",companyId:").concat(companyId.toString())
            .concat(",inventoryTypeCode:")
            .concat(typecode.toString()).concat(",purposeCode!2")
            // .concat('&page=').concat(pageNum)
            .concat('&excel=') + isExcel;
        return this.getExcel(urlForExcel);

    }

    getExcelByAssignmentTypePage(compId: number, page: number, size: number, isExcel: boolean) {
        var urlForExcel = global.BY_ASSIGN_TYPE_FILTER
            .concat("companyId=").concat(compId.toString())
            .concat("&page=").concat(page.toString())
            .concat("&size=").concat(size.toString()).concat('&excel=') + isExcel;
        return this.getExcel(urlForExcel);

    }

    getCityExcel(isExcel: boolean) {
        var urlForExcel = global.GET_ALL_CITY_URL.concat('?excel=') + isExcel;
        return this.getExcel(urlForExcel);

    }

    getResselerExcel(isExcel: boolean) {
        var urlForExcel = global.GET_ALL_CRM_RESELLER.concat('?excel=') + isExcel;
        return this.getExcel(urlForExcel);

    }

    getPartnerExcel(isExcel: boolean) {
        var urlForExcel = global.GET_ALL_CRM_PARTNERS.concat('?excel=') + isExcel;
        return this.getExcel(urlForExcel);

    }

    getGenericReasonExcel(isExcel: boolean) {
        var urlForExcel = global.GET_ALL_GENERIC_REASONS.concat('?excel=') + isExcel;
        return this.getExcel(urlForExcel);

    }

    

    getExcelByAssignmentFilter(query: string, page: number, size: number, isExcel: boolean) {
        var urlForExcel = global.BY_ASSIGN_TYPE_FILTER.concat(query).
            concat("&page=").concat(page.toString()).concat("&size=").concat(size.toString()).concat('&excel=') + isExcel;
        return this.getExcel(urlForExcel);

    }

    getExcelRevertHistory(page: number, size: number, isExcel: boolean) {
        var urlForExcel = global.BY_REVERT_INVENTORY.
            concat("page=").concat(page.toString()).concat("&size=").concat(size.toString()).concat('&excel=') + isExcel;
        return this.getExcelCsv(urlForExcel);
    }

    getExcelnewcsv(){
        return this.getExcelCsv("http://103.21.187.3:8095/tripleplay/testing/download");
    }

    getExcelFilterRevertHistory(query:string, page: number, size: number, isExcel: boolean) {
        var urlForExcel = global.BY_FILTERED_REVERT_INVENTORY.concat(query).
            concat("&page=").concat(page.toString()).concat("&size=").concat(size.toString()).concat('&excel=') + isExcel;
        return this.getExcelCsv(urlForExcel);
    }

    getExcelAllCompany(isExcel: boolean) {
        var isFromMainBranch: string;
        isFromMainBranch = sessionStorage.getItem('isFromMainBranch');
        var urlForExcel = global.GET_ALL_COMPANY_BRANCHES.concat('?all=').concat(isFromMainBranch).concat('&excel=') + isExcel;

        return this.getExcel(urlForExcel);
    }


    getExcelUserCompanyAndPageEmbed(companyId, pageNum, isExcel) {
        var isFromMainBranch: string;
        isFromMainBranch = sessionStorage.getItem('isFromMainBranch');
        console.log('test  '+ isFromMainBranch);
        var urlForExcel = global.GET_USERS_BY_PAGE.concat("?embed=inventoryCount,role,manager,company")
            .concat('&all=').concat(isFromMainBranch)
            .concat("&page=").concat(pageNum).concat('&excel=') + isExcel;
        return this.getExcel(urlForExcel);
    }

    getExcelUserCompanyAssigned(boolString, pageNum, isExcel) {
        var isFromMainBranch: string;
        isFromMainBranch = sessionStorage.getItem('isFromMainBranch');
        var urlForExcel = global.GET_ASSIGNED_EMPLOYEES
            .concat("?embed=inventoryCount,role,manager,company")
            .concat("&all=", isFromMainBranch)
            .concat("&page=").concat(pageNum).concat('&excel=') + isExcel;
        return this.getExcel(urlForExcel);

    }

    getExcelUserInventoryAssigned(isExcel:boolean){
        var urlForExcel = global.GET_EMPLOYE_WITH_ASSIGNED_INV.concat("?excel=")+isExcel;
        return this.getExcel(urlForExcel);
    }




    getStockTransferExcel(typecode, purposeCode, fromCompId) {
        let urlForExcel = global.GET_ALL_INVENTORY_QUERY.concat("inventoryTypeCode:")
            .concat(typecode.toString()).concat(",isCompleted:false").concat(",purposeCode:")
            .concat(purposeCode.toString())
            .concat('&embed=company,stockTransferEmployee,user,checkin')
            .concat(',fromCompanyId:').concat(fromCompId.toString())
            .concat('&excel=true')
            .concat('&typeCode=').concat('3');
        return this.getExcel(urlForExcel);
    }

    getStockTransferFilterExcel(typecode, purposeCode, fromCompId, query) {
        let urlForExcel = global.GET_ALL_INVENTORY_QUERY.concat("inventoryTypeCode:")
            .concat(typecode.toString()).concat(",isCompleted:false").concat(",purposeCode:")
            .concat(purposeCode.toString())
            // .concat(',fromCompanyId:').concat(fromCompId.toString())
            .concat("," + query)
            .concat('&embed=company,stockTransferEmployee,user,checkin')
            .concat('&excel=true')
            .concat('&typeCode=').concat('3');
        return this.getExcel(urlForExcel);
    }

    getCheckOutFilterExcel(typecode,fromCompanyId,query){
        let urlForExcel = global.GET_ALL_INVENTORY_QUERY.concat("inventoryTypeCode:")
            .concat(typecode.toString()).concat(",isCompleted:false,purposeCode:1,")
            .concat(query)
            .concat('&excel=true').concat("&typeCode=").concat('2');
        
        return this.getExcel(urlForExcel);
    }

    getCheckOutExcel(typecode,fromCompanyId){
        let urlForExcel = global.GET_ALL_INVENTORY_QUERY.concat("inventoryTypeCode:")
            .concat(typecode.toString()).concat(",isCompleted:false,purposeCode:1")
            .concat('&excel=true').concat("&typeCode=").concat('2');
        return this.getExcel(urlForExcel);
    }

    // userAttendance/dates?from=27-02-2018&till=27-03-2018

    getUserAttendanceExcel(fromDate:string, tillDate:string) {
        let urlForExcel = global.GET_ALL_ATTENDANCE_EXCEL.concat(fromDate)
       .concat("&till=").concat(tillDate);

        return this.getExcel(urlForExcel);
    }
    getUserAttendanceExcelByManagerId(managerId:number, date:string) {
        let urlForExcel = global.GET_ALL_EMPLOYEE_BY_REPORTING_MANAGER
            .concat(managerId.toString()).concat("&from=")
            .concat(date)
            .concat("&excel=true") ;
        return this.getExcel(urlForExcel);
    }
    getUserAttendanceExcelFormat() {
        let urlForExcel = global.GET_ALL_EMPLOYEE_EXCEL_FORMAT;
        return this.getExcel(urlForExcel);
    }



    // get excel api
    getExcel(url) {
        console.log(url);
        let headers = new Headers();
        headers.set('token', sessionStorage.getItem('token'))
        return this.http.get(url, {
            headers: headers,
            responseType: ResponseContentType.Blob,
        }).map(
            res => new Blob([res['_body']],
            { type: 'application/vnd.ms-excel' }));
    }

    getExcelCsv(url) {
        console.log(url);
        let headers = new Headers();
        headers.set('token', sessionStorage.getItem('token'))
        return this.http.get(url, {
            headers: headers,
            responseType: ResponseContentType.Blob
        }).map(
            res => res);
    }


    getExcelSalesByLocation(isExcel: boolean ){

      var urlForExcel = global.GET_EXCEL_LOCATION_MASTER
          .concat("?page=1").concat('&excel=') + isExcel;
          return this.getExcel(urlForExcel);
     }







}


